import styled, { css } from 'styled-components';

import enabled from '~/components/svg-icon/images/ic-24-radio-enabled.svg';
import selected from '~/components/svg-icon/images/ic-24-radio-selected.svg';
import off from '~/components/svg-icon/images/ic-24-checkbox-enabled.svg';
import on from '~/components/svg-icon/images/ic-24-checkbox-checked.svg';

const inputStd = css`
  padding: 10px 16px;
  color: #222222;
  font-size: 14px;
  line-height: 24px;
  border: 1px solid #EDEDED;
  border-radius: 2px;
  background-color: #FFFFFF;
  transition: all 150ms ease-out;

  &:focus {
    border-color: #222222;
  }

  &:disabled {
    color: #CCCCCC;
    border-color: #EDEDED;
    background-color: #FCFCFC;

    &::placeholder {
      color: #CCCCCC;
    }
  }
`;

const radioStd = css`
  width: 24px;
  height: 24px;
  margin: 0;
  border: 0;
  border-radius: 0;
  background-image: url(${enabled}) ;
  background-size: cover;
  appearance: none;
  cursor: pointer;

  &:checked {
    background-image: url(${selected});
  }
`;

const checkStd = css`
  width: 24px;
  height: 24px;
  margin: 0;
  border: 0;
  border-radius: 0;
  background: url(${off}) center center no-repeat;
  background-size: cover;
  appearance: none;

  &:checked {
    background-image: url(${on});
  }
`;

export const Wrap = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 8vh auto;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;

    > h1 {
      width: 100%;
    }
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 20px;
  background-color: #EEEEEE;
  margin-bottom: 20px;
  border-radius: 4px;

  &:after {
    content: '';
    display: block;
    width: ${({ step }) => step * 10}%;
    height: 100%;
    background-color: blue;
    border-radius: 4px;
  }
`;

export const QuestionWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > p {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;

    > span {
      margin-left: 4px;
      color: #3E26FD;
    }
  }

  & + & {
    margin-top: 32px;
  }
`;

export const InputWrap = styled.div`
  display: inline-flex;
  flex-direction: column;
  margin-top: 12px;
  margin-bottom: 12px;
  width: 100%;
`;

export const Label = styled.label`
  display: inline-flex;
  flex-direction: column;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  -ms-touch-action: manipulation;
  touch-action: manipulation;

  > p {
    margin-bottom: 8px;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;

    > span {
      margin-left: 4px;
      color: #3E26FD;
    }
  }
`;

export const Input = styled.input`
  ${inputStd};

  &.left {
    text-align: left;
  }
  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
`;

export const RadioRow = styled.div`
  display: flex;
  align-items: center;

  label {
    min-width: 160px;
  }

  label + label {
    margin-left: 4px;
  }
`;

export const RadioLabel = styled.label`
  display: inline-flex;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
`;

export const Radio = styled.input`
  ${radioStd};
  margin-right: 4px;
`;

export const Textarea = styled.textarea`
  height: 80px;
  margin-top: 8px;
  padding: 10px 16px;
  font-size: 14px;
  line-height: 24px;
  resize: none;
  border-radius: 2px;
  border: 1px solid #EDEDED;
  background-color: #FFFFFF;
  transition: all 150ms ease-out;

  &:focus {
    border-color: #222222;
  }
`;

export const CheckLabel = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
`;

export const Check = styled.input`
  ${checkStd};
  flex: none;
`;

export const TextContent = styled.div`
  margin-left: 4px;
  color: #222222;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;

  > span {
    white-space: pre-wrap;
  }
`;


export const BtnWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 48px;

  > button + button {
    margin-left: 16px;
  }
`;

export const BlueButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  padding: 0px 16px;
  font-weight: 700;
  vertical-align: middle;
  transition: all 150ms ease-out 0s;
  cursor: pointer;
  background-color: rgb(50, 108, 249);
  border: 1px solid rgb(50, 108, 249);
  border-radius: 2px;
  color: rgb(255, 255, 255);
  height: 56px;

  &:hover {
    background-color: rgb(30, 65, 208);
    border-color: rgb(30, 65, 208);
  }

  &:disabled {
    border: 1px solid rgb(223, 223, 223);
    background-color: rgb(223, 223, 223);
  }
`;

export const GrayButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  padding: 0px 16px;
  font-weight: 700;
  vertical-align: middle;
  transition: all 150ms ease-out 0s;
  cursor: pointer;
  background-color: #FFFFFF;
  border: 1px solid rgb(223, 223, 223);
  border-radius: 2px;
  color: rgb(34, 34, 34);
  height: 56px;

  &:hover {
    background-color: rgb(250, 250, 250);
    border: 1px solid rgb(223, 223, 223);
  }
`;

export const CompleteImg = styled.img`
  width: 88px;
  height: 88px;
  margin-bottom: 32px;
  object-fit: cover;
  font-family: 'object-fit: cover;';
`;

export const NoticeWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 32px;
  padding: 12px 0;
  background-color: #facfd6;
`;

export const Notice = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 32px;
  color: red;
  padding: 0 12px;
`;

export const Terms = styled.div`
  margin: 12px 0;
  width: 100%;
  max-height: 80px;
  padding: 12px;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  color: #222222;
  border: 1px solid rgb(223, 223, 223);
  overflow-y: scroll;
`;
